var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarcodeUpWhiteArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 37,
    viewBox: "0 0 21 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1817 1.38008e-08C10.4888 4.73774e-05 10.796 0.117169 11.0303 0.351562L19.9815 9.30273C20.4502 9.77172 20.4502 10.532 19.9815 11.001C19.5129 11.4693 18.7529 11.4691 18.2842 11.001L11.3428 4.05957V35.3994C11.3428 36.0488 10.8155 36.5762 10.166 36.5762C9.51665 36.5759 8.99025 36.0486 8.99025 35.3994V4.05957L2.04884 11.001C1.58017 11.4692 0.820412 11.4691 0.351574 11.001C-0.117192 10.532 -0.117191 9.77172 0.351574 9.30273L9.30275 0.351562C9.5371 0.1172 9.84421 -4.6444e-05 10.1514 1.38008e-08H10.1817Z",
    fill: "url(#paint0_linear_10_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_10",
    x1: 10.1665,
    y1: 0,
    x2: 10.1665,
    y2: 36.5762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeUpWhiteArrow);
export default __webpack_public_path__ + "static/media/barcode-up-white-arrow.12bee05128f947120c816f2da9e5322e.svg";
export { ForwardRef as ReactComponent };